import { AdminFormDto, FormSubmissionDto } from '@completion/models';
import { CheckSheetActionTypes, DynamicFormAction, DynamicFormActionTypes } from '@completion/actions';

export interface DynamicFormState {
  dynamicFormConnectionLoadStatus: 'idle' | 'loading' | 'success' | 'error';
  dynamicFormConnectionLoadError: string | null;
  connectedFormGuids: string[];
  dynamicFormLoadStatus: 'idle' | 'loading' | 'success' | 'error';
  dynamicFormLoadError: string | null;
  dynamicFormData: AdminFormDto[] | null;
  dynamicFormSubmissions: FormSubmissionDto[] | null;
  dynamicFormSaveStatus: 'idle' | 'saving' | 'success' | 'error';
  dynamicFormSaveError: string | null;
}

export const initialState: DynamicFormState = {
  dynamicFormConnectionLoadStatus: 'idle',
  dynamicFormConnectionLoadError: null,
  connectedFormGuids: [],
  dynamicFormLoadStatus: 'idle',
  dynamicFormLoadError: null,
  dynamicFormData: null,
  dynamicFormSubmissions: null,
  dynamicFormSaveStatus: 'idle',
  dynamicFormSaveError: null,
};

export function dynamicFormReducer(
  state: DynamicFormState = initialState,
  action: DynamicFormAction | { type: CheckSheetActionTypes.ClearCurrentCsa },
): DynamicFormState {
  switch (action.type) {
    case CheckSheetActionTypes.ClearCurrentCsa:
      return {
        ...state,
        dynamicFormConnectionLoadStatus: 'idle',
        dynamicFormConnectionLoadError: null,
        connectedFormGuids: [],
        dynamicFormLoadStatus: 'idle',
        dynamicFormLoadError: null,
        dynamicFormData: null,
        dynamicFormSubmissions: null,
        dynamicFormSaveStatus: 'idle',
        dynamicFormSaveError: null,
      };
    case DynamicFormActionTypes.ResetDynamicFormConnections:
      return {
        ...state,
        dynamicFormConnectionLoadStatus: 'idle',
        dynamicFormConnectionLoadError: null,
        connectedFormGuids: [],
      };
    case DynamicFormActionTypes.LoadDynamicFormConnections:
      return {
        ...state,
        dynamicFormConnectionLoadStatus: 'loading',
        dynamicFormConnectionLoadError: null,
      };
    case DynamicFormActionTypes.LoadDynamicFormConnectionsSuccess:
      return {
        ...state,
        dynamicFormConnectionLoadStatus: 'success',
        dynamicFormConnectionLoadError: null,
        connectedFormGuids: action.connectedFormGuids,
      };
    case DynamicFormActionTypes.LoadDynamicFormConnectionsFailure:
      return {
        ...state,
        dynamicFormConnectionLoadStatus: 'error',
        dynamicFormConnectionLoadError: action.errorMessage,
        connectedFormGuids: [],
      };
    case DynamicFormActionTypes.LoadDynamicFormData:
      return {
        ...state,
        dynamicFormLoadStatus: 'loading',
        dynamicFormLoadError: null,
        dynamicFormData: null,
        dynamicFormSubmissions: null,
      };
    case DynamicFormActionTypes.LoadDynamicFormDataSuccess:
      return {
        ...state,
        dynamicFormLoadStatus: 'success',
        dynamicFormLoadError: null,
        dynamicFormData: action.forms,
        dynamicFormSubmissions: action.submissions,
      };
    case DynamicFormActionTypes.LoadDynamicFormDataFailure:
      return {
        ...state,
        dynamicFormLoadStatus: 'error',
        dynamicFormLoadError: action.errorMessage,
        dynamicFormData: null,
        dynamicFormSubmissions: null,
      };
    case DynamicFormActionTypes.SaveDynamicForm:
      return {
        ...state,
        dynamicFormSaveStatus: 'saving',
        dynamicFormSaveError: null,
      };
    case DynamicFormActionTypes.SaveDynamicFormSuccess:
      return {
        ...state,
        dynamicFormSaveStatus: 'success',
        dynamicFormSaveError: null,
      };
    case DynamicFormActionTypes.SaveDynamicFormFailure:
      return {
        ...state,
        dynamicFormSaveStatus: 'error',
        dynamicFormSaveError: action.errorMessage,
      };
    default:
      return state;
  }
}
